import { CheckCircledIcon, ExclamationTriangleIcon } from '@radix-ui/react-icons'
import { Text, Badge, Flex } from '@radix-ui/themes'
import { EiffageScan } from '@willie/schemas'
import { STATUS_LABELS } from '../-constant'

interface Props {
  scanStatus: EiffageScan['status']
}

const StatusBadge = ({ scanStatus }: Props) => {
  return (
    <Badge
      size={'3'}
      variant="soft"
      color={
        scanStatus === 'completed'
          ? 'green'
          : scanStatus === 'processing' || scanStatus === 'pending'
            ? 'pink'
            : scanStatus === 'validation'
              ? 'blue'
              : 'orange'
      }
    >
      <Flex align={'center'} justify={'center'} gap="2">
        {scanStatus === 'completed' ? (
          <CheckCircledIcon />
        ) : scanStatus === 'processing' || scanStatus === 'pending' ? (
          <div className="w-[11px] h-[11px] rounded-full bg-pink-400 animate-pulse" />
        ) : scanStatus === 'validation' ? null : (
          <ExclamationTriangleIcon />
        )}
        <Text size="1" weight="medium">
          {STATUS_LABELS[scanStatus]}
        </Text>
      </Flex>
    </Badge>
  )
}

export default StatusBadge
